import { render, staticRenderFns } from "./DocCallout.vue?vue&type=template&id=7a08801a&scoped=true&"
import script from "./DocCallout.vue?vue&type=script&lang=js&"
export * from "./DocCallout.vue?vue&type=script&lang=js&"
import style0 from "./DocCallout.vue?vue&type=style&index=0&id=7a08801a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a08801a",
  null
  
)

export default component.exports